var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"legal-footer-links",attrs:{"aria-label":"Yasal bilgilendirme bağlantıları"}},[_c('b-link',{attrs:{"to":{ name: 'legal-hub' }}},[_vm._v(" Bilgilendirme Metinleri'ne ulaşmak için tıklayınız ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }